import { useCallback, useEffect, useState } from "react";
import Table from "../../common/Table";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import { LuPencilLine } from "react-icons/lu";
import { AiOutlineDelete } from "react-icons/ai";
import { toast } from "react-toastify";
import { useFormik } from "formik";
import ConfirmationPage from "../../common/ConfirmationPage";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../constant";
import { addContact, deleteContact, editContact, getAllContact } from "../../redux/services/contactSlice";

const ContactUs = () => {
  const dispatch = useDispatch();
  const getContactData = useSelector((state) => state?.contact?.contactData);

  const navigate = useNavigate();
  const [page, setPage] = useState(0);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [confirm, setConfirm] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchData, setSearchData] = useState("");
  const limitOptions = [
    { value: 10, label: 10 },
    { value: 30, label: 30 },
    { value: 50, label: 50 },
    { value: 100, label: 100 },
  ];
  const [pageLimit, setPageLimit] = useState(limitOptions[0]?.value);

  const initialValues = {};
  const validationSchema = Yup.object({});

  const getAllContacts = useCallback(async () => {
    try {
      await dispatch(
        getAllContact({ page: page + 1, limit: pageLimit, searchData })
      );
    } catch (error) {}
  }, [dispatch, page, pageLimit, searchData]);

  useEffect(() => {
    getAllContacts();
  }, [getAllContacts]);

  const onSubmit = async () => {};

  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    handleSubmit,
    setValues,
    resetForm,
  } = useFormik({
    initialValues,
    validationSchema,
    onSubmit,
  });

  const deleteContactData = async () => {
    try {
      const response = await dispatch(deleteContact(itemToDelete));
      toast.success(response?.payload?.message, {
        autoClose: 2000,
        pauseOnHover: false,
      });
      setConfirm(false);
      getAllContacts();
    } catch (error) {}
  };

  const columns = [
    {
      header: "S/N",
      key: "index",
      render: (_, __, index) => page * pageLimit + index + 1,
    },
    { header: "Name", key: "name" },
    { header: "Email", key: "email" },
    { header: "Phone", key: "phone" },
    { header: "Website", key: "website" },
    { header: "Company", key: "company" },
    { header: "Message", key: "message" },
    
  ];

  const actions = [
    {
      icon: <LuPencilLine className="w-5 h-5" />,
      onClick: (row) => {
        navigate(`${ROUTES.WEBSITE.CONTACT_ENQUIRIES_EDIT}?contactId=${row._id}`, { state: { row } });
      },
    },
    {
      icon: <AiOutlineDelete className="w-6 h-6" />,
      onClick: (row) => {
        setItemToDelete(row._id);
        setConfirm(true);
      },
    },
  ];

  return (
    <>
      <Table
        title="Contact Enquiries"
        buttonTitle="Add Contact"
        showSearchbar={true}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        setSearchData={setSearchData}
        onAddClick={() => navigate(ROUTES.WEBSITE.CONTACT_ENQUIRIES_ADD)}
        columns={columns}
        data={getContactData?.contact_us_data || []}
        actions={actions}
        pageCount={getContactData?.state?.page_limit}
        onPageChange={(selectedItem) => setPage(selectedItem.selected)}
        pageLimitOptions={limitOptions}
        selectedPageLimit={pageLimit}
        onPageLimitChange={setPageLimit}
      />
      {confirm && (
        <ConfirmationPage
          topicName="Contact"
          confirm={confirm}
          onDelete={deleteContactData}
          onCancel={() => setConfirm(false)}
        />
      )}

    </>
  );
};

export default ContactUs;
